import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface PopupTitleProps {
  children: ReactNode;
}

export function PopupTitle({ children }: PopupTitleProps) {
  return children ? (
    <Typography
      sx={{
        fontWeight: 'bold',
        mb: 1,
        fontSie: '0.75rem',
      }}
    >
      {children}
    </Typography>
  ) : null;
}
